import React, { useEffect, useMemo, useState } from 'react';
import './sideFilterSortBy.less';
import { SortBy } from '../../interface';
import { Button, Select, Skeleton, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import {
  updateModalSideFilters,
  updateSiteFilter,
} from '../../../../modules/SearchDatePicker/searchDatePickerSlice';
import useGetAttributeTranslation from '../../hooks/useGetAttributeTranslation';

interface Props {
  filter: SortBy;
  withModalScopeParams?: boolean;
  isLoading?: boolean;
  additionalPrice?: number;
  hideApplyButton?: boolean;
  localSideFilters?: Record<string, any> | null;
  setLocalSideFilters?: (f: Record<string, any>) => void;
}

const SideFilterSortBy = ({
  filter,
  withModalScopeParams,
  isLoading,
  additionalPrice = 0,
  hideApplyButton = false,
  localSideFilters,
  setLocalSideFilters
}: Props) => {

  const dispatch = useDispatch();
  const { sideFilters: reduxSideFilters, modalSideFilters } = useSelector(
    (state: RootState) => {
      return state.search;
    }
  );
  const sideFilters = useMemo(
    () => (localSideFilters ? localSideFilters : withModalScopeParams ? modalSideFilters : reduxSideFilters),
    [withModalScopeParams, modalSideFilters, reduxSideFilters, localSideFilters]
  );
  const { sideFilters: side_filters_t, general: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  const options = useMemo(
    () =>
      filter.options.map((el) => {
        if (typeof el !== 'string') {
          return {
            value: el?.id,
            label: side_filters_t[el?.name] ?? t[el?.name] ?? el?.name,
          };
        } else {
          return { value: el, label: side_filters_t[el] ?? t[el] ?? el };
        }
      }),
    [filter.options]
  );

  const [selectedOption, setSelectedOption] = useState(
    sideFilters?.[filter.attr] || ''
  );
  const attributeTranslation = useGetAttributeTranslation();

  useEffect(() => {
    if (!sideFilters?.[filter.attr]) {
      setSelectedOption('');
    }
  }, [sideFilters, filter.attr, options]);


  const isAttractions = window.location.pathname.includes('attractions');
  useEffect(() => {
    if (
      !selectedOption &&
      sideFilters?.[filter.attr] &&
      !!options?.length &&
      isAttractions
    ) {
      setSelectedOption(options[0].value);
    }
  }, [selectedOption, sideFilters, options, filter.attr, isAttractions]);

  // helper that updates either local filters (if provided) or redux
  const commitFilter = (key: string, value: any) => {
    if (setLocalSideFilters) {
      // update local copy immutably
      setLocalSideFilters({
        ...(localSideFilters || {}),
        [key]: value,
      });
      return;
    }
    const fn = withModalScopeParams ? updateModalSideFilters : updateSiteFilter;
    dispatch(fn({ key, value }));
  };

  const handleSubmit = (e?: any) => {
    commitFilter(filter.attr, e !== undefined ? e : selectedOption);
  };

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  return (
    <div className="sortBy-sidefilter">
      <h2>{attributeTranslation(filter.attr)}</h2>
      <Space.Compact>
        <Select
          allowClear={!(isAttractions && selectedOption === options[0].value)}
          className="select"
          placeholder={t.sort}
          optionFilterProp="label"
          onChange={(e) => {
            setSelectedOption(e);
            if (hideApplyButton) {
              handleSubmit(e === undefined ? null : e);
            }
          }}
          value={selectedOption}
          options={options}
        />
        {!hideApplyButton && (
          <Button
            type="primary"
            className="btn-style-5"
            onClick={() => handleSubmit()}
          >
            {t.sort}
          </Button>
        )}
      </Space.Compact>
    </div>
  );
};

export default SideFilterSortBy;
